import cookie from 'cookie';

export function getCookieByName(name = 'CookieConsent') {
    const cookies = cookie.parse(document.cookie)
    if(cookies[name])
    {
        if(cookies[name]==="true")
        {
            return true;
        }
        else
        {
            return false;
        }
    }
    else
    {
        return false;
    }
}